import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

// import { } from '../store/slices';

function usePageNavigation() {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const { pathname } = useLocation();

  const navigateNextPage = useCallback((toPage) => {
    sessionStorage.setItem('visitedRoute', `/${toPage}`);
    navigate(`/${toPage}`);
  }, [navigate]);

  const nagivatePreviousPage = useCallback((toPage) => {
    sessionStorage.setItem('visitedRoute', `/${toPage}`);
    navigate(`/${toPage}`);
  }, [navigate]);

  return {
    navigateNextPage,
    nagivatePreviousPage,
  };
}

export default usePageNavigation;
